import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { LoadingService } from '@farris/ui-loading';
import { MessagerService } from '@farris/ui-messager';
import { BsModalService } from '@farris/ui-modal';
import { NotifyService } from '@farris/ui-notify';

import { DocuTypeHelperEntity } from '../entity/DocuTypeHelperEntity';
import { BillTypeHelpService } from '../bill-type-help.service';
import { NodeSelectedParam, TreeNode, TreeTableComponent } from '@farris/ui-treetable';
import { AifLocalePipe, BIF_LANG_RESOURCES } from '../../aif-ui-common/pipe/aif-ui-common-locale.pipe';
import { BILL_TYPE_HELP_LANG_RESOURCES } from '../i18n/lang.resource';

@Component({
  selector: 'app-bill-type-help',
  templateUrl: './bill-type-help.component.html',
  styleUrls: ['./bill-type-help.component.css'],
  providers: [
    { provide: BIF_LANG_RESOURCES, useValue: BILL_TYPE_HELP_LANG_RESOURCES },
    AifLocalePipe,
  ]
})
export class BillTypeHelpComponent implements OnInit {
  @Output("onselected")
  onselected = new EventEmitter<DocuTypeHelperEntity>();

  @ViewChild('tt')
  tt: TreeTableComponent;
  ttData: TreeNode[];
  ttCols: any[];
  ttIdField = 'id';
  ttSearchFields: {
    label: string;
    value: string;
  }[] = [];
  ttSearchObj: { field: string, value: string };
  ttAllColumnsTitle: string = this.localePipe.instant("allColumns");

  docuTypeList: DocuTypeHelperEntity[] = [];

  docuTypeId: string;

  constructor(
    private entityService: BillTypeHelpService,
    private messager: MessagerService,
    private notify: NotifyService,
    private modal: BsModalService,
    private loading: LoadingService,
    private localePipe: AifLocalePipe,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.configLookupColumns();
    this.loadItems();
  }

  getSelectedDocuType(): DocuTypeHelperEntity {
    return this.tt.selectedRow && this.tt.selectedRow.data;
  }

  /**
   * 左侧树表搜索事件
   */
  ttSearch(obj: { field: string, value: string }) {
    this.ttSearchObj = obj;
    this.ttSearchObj && this.tt.searchHandle.search(this.ttSearchObj.field, this.ttSearchObj.value);
  }


  loadItems() {
    let entities$: Observable<DocuTypeHelperEntity[]> = null;
    entities$ = this.entityService.findDocumentTypeEntites();
    const l = this.loading.show({ message: this.localePipe.instant("loading") });
    entities$.subscribe(
      (entities: DocuTypeHelperEntity[]) => {
        l.close();
        this.ttData = [...this.buildTreeData(entities)];
        this.docuTypeList = entities;
        setTimeout(() => {
          this.tt.expandAll();
          if (this.docuTypeId) {
            this.tt.selectNode(this.docuTypeId);
          } else {
            //默认选中第一条数据
            this.docuTypeList && this.docuTypeList.length > 0 && this.tt.selectNode(this.docuTypeList[0].id);
          }
        }, 100);
      },
      (err) => {
        l.close();
        //todo 确定异常结构, 目前采用兼容取值方式
        this.messager.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
        throw err;
      }
    );
  }

  ttNodeSelected(nsp: NodeSelectedParam) {
    let rows: TreeNode[] = [];
    if (Array.isArray(nsp.node)) {
      const arr: TreeNode[] = nsp.node;
      arr.forEach(it => {
        rows.push(it);
      });
    } else {
      rows.push(nsp.node);
    }
    if (rows.length == 0) {
      return;
    }
    let row = rows[0];
    this.docuTypeId = row.id;
  }

  buildTreeData(entities: DocuTypeHelperEntity[]): TreeNode[] {
    const nodes: TreeNode[] = [];
    const map: {
      [key: string]: DocuTypeHelperEntity[]
    } = {};
    entities && entities.forEach(it => {
      if (map[it.bizKindName] == null) {
        map[it.bizKindName] = [it];
      } else {
        map[it.bizKindName].push(it);
      }
    });

    Object.keys(map).forEach(key => {
      const node: TreeNode = {
        id: key,
        data: {
          id: key,
          bizKindName: key,
          treeInfo: {
            layer: 1,
          }
        },
        selectable: false,
        leaf: false,
      };

      const children = map[key].map(it => {
        const node: TreeNode = {
          id: it.id,
          data: {
            ...it,
            treeInfo: {
              layer: 2,
              parentId: key,
            },
          },
          selectable: true,
          leaf: true
        };

        return node;
      });

      node.children = children;

      nodes.push(node);
    });

    return nodes;
  }

  private configLookupColumns() {
    this.ttCols = [
      { field: "bizKindName", title: this.localePipe.instant("busineseCategory"), width: 100 },
      { field: "name", title: this.localePipe.instant("name"), width: 80 },
      { field: "code", title: this.localePipe.instant("code"), width: 80 },
      { field: "moduleName", title: this.localePipe.instant("module"), width: 100 },
      { field: "bizTypeName", title: this.localePipe.instant("busineseType"), width: 100 },
    ];
  }
}
